import type {
  AutotraderFlagNames,
  CC9FlagNames,
  TestFlagNames
} from "@dealer-center/core-interfaces-third-party-launch-darkly";
import type { GenericFlags } from "@dealer-center/core-interfaces-third-party-launch-darkly";

import { useFlags as useFlagsReal } from "launchdarkly-react-client-sdk";

// export const useFlags = useFlagsReal as () => launchDarklyToggles;

export const useTestFlags = useFlagsReal as () => GenericFlags<TestFlagNames>;

export const useCC9Flags = useFlagsReal as () => GenericFlags<CC9FlagNames>;

export const useAutotraderFlags =
  useFlagsReal as () => GenericFlags<AutotraderFlagNames>;
